<template>
  <div class="accordion-panel" :class="{ expanded: expanded }">
    <div class="accordion-header" @click="$emit('toggle', 'willCreation')">
      <div class="header-main">
        <div class="header-icon">
          <v-icon
            :color="
              allStepsCompleted
                ? this.whitelabel.colors.leftPanelGreen
                : this.whitelabel.colors.leftPanelIconGrey
            "
            size="24"
          >
            {{ icons.mdiCheckCircle }}
          </v-icon>
        </div>

        <div class="header-title">
          <h3>WILL CREATION</h3>
        </div>

        <div class="header-chevron">
          <v-icon color="#666" size="20">
            {{ expanded ? icons.mdiChevronUp : icons.mdiChevronDown }}
          </v-icon>
        </div>
      </div>
    </div>

    <div class="expanded-container" :class="{ expanded: expanded }">
      <div class="status-container">
        <p class="status-text d-flex align-center">
          <span> Steps completed:</span>
          <span class="status-value-steps ml-2"
            >{{ numberOfCompletedSteps }} of {{ totalSteps }}</span
          >
        </p>
      </div>

      <div class="accordion-content">
        <div class="content-wrapper">
          <div class="section-content">
            <div class="content-margins">
              <h4>What is next?</h4>
              <p v-html="descriptionText"></p>
            </div>

            <div class="action-buttons will-creation">
              <DownloadWill
                :disabled="downloadDisabled"
                :testator="testator"
                :call-to-action="callToAction"
                :willDetailsChanged.sync="willDetailsChanged"
                @willDownloaded="$emit('willDownloaded')"
              />
              <PreviewWill
                :disabled="downloadDisabled"
                :testator="testator"
                :call-to-action="callToActionPreview"
                :previewWillDetailsChanged.sync="previewWillDetailsChanged"
                @previewWillDownloaded="$emit('previewWillDownloaded')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mdiChevronDown, mdiChevronUp, mdiCheckCircle } from '@mdi/js';
  import DownloadWill from '../../common/DownloadWill';
  import PreviewWill from '../../common/PreviewWill';
  import Revise from '../../../helpers/reviseStep';

  export default {
    name: 'WillCreation',
    components: {
      DownloadWill,
      PreviewWill,
    },
    props: {
      expanded: {
        type: Boolean,
        default: false,
      },
      testator: {
        type: Object,
        required: true,
      },
      numberOfCompletedSteps: {
        type: Number,
        required: true,
        default: 1,
      },
      totalSteps: {
        type: Number,
        required: true,
        default: 0,
      },
      allStepsCompleted: {
        type: Boolean,
        required: true,
        default: false,
      },
      willDetailsChanged: {
        type: Boolean,
        required: true,
        default: false,
      },
      previewWillDetailsChanged: {
        type: Boolean,
        required: true,
        default: false,
      },
      latestVersionStatus: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        icons: {
          mdiChevronDown: mdiChevronDown,
          mdiChevronUp: mdiChevronUp,
          mdiCheckCircle: mdiCheckCircle,
        },
      };
    },
    computed: {
      willValid() {
        return this.latestVersionStatus === 'valid';
      },
      downloadDisabled() {
        if (this.hasStepToRevise) {
          return true;
        } else {
          return this.numberOfCompletedSteps != this.totalSteps;
        }
      },
      callToAction() {
        return !this.testator.willVersions.length || this.willDetailsChanged;
      },
      callToActionPreview() {
        return (
          !this.testator.previewWillVersions.length ||
          this.previewWillDetailsChanged
        );
      },
      hasStepToRevise() {
        return Revise.anyStepsToRevise(this.testator);
      },
      descriptionText() {
        if (this.numberOfCompletedSteps < this.totalSteps) {
          return `You need to complete
                <strong>all 7 steps in the setup section</strong>. Once that is
                done you can download and preview the complete will.`;
        } else if (
          this.allStepsCompleted &&
          this.latestVersionStatus === 'not uploaded'
        ) {
          return `You can now <strong>download your will and check that all the details are correct</strong>.<br /><br />If you are happy with your will you can <strong>sign it and upload it for verification</strong> in the next step.`;
        } else if (
          this.allStepsCompleted &&
          (this.willDetailsChanged || this.latestVersionStatus !== 'valid')
        ) {
          return `You have made changes to your will, If you would like the changes to reflect, you will need to <strong>download your will and sign it</strong> before you can start the <strong>verification process </strong>again.`;
        } else if (this.allStepsCompleted && this.willValid) {
          if (!this.testator.dateStored) {
            return `Congratulations! Your will is <strong>complete and valid</strong>.<br /><br />You can now store your will in the <strong>Old Mutual Wills Vault</strong> if you so choose.`;
          } else {
            return `Congratulations! Your will is <strong>complete and valid</strong>.`;
          }
        } else {
          return `You can now <strong>download your will and check that all the details are correct</strong>. If you are happy with your will you can <strong>sign it and upload it for verification</strong> in the next step.`;
        }
      },
    },
  };
</script>
